import getRecommendations from '../recommendation/recommendation';
import {
  SET_PAGE_ID, SET_PANEL_LOADED_STATE, SET_RECOMMENDATIONS, SET_WISHLIST_LOADED,
} from '../type/mutations';
import GET_RECOMMENDATIONS from '../type/actions';
import prosZones from '../utils/prosZones';
import getWorkflow from './storeHelper';
import { generateUniqueString, getPersistent } from '../utils/utils';

const PDP_ZONE_A_LS_KEY = 'PDP_ZONE_A_ProductIds';
const PDP_ZONE_G_LS_KEY = 'PDP_ZONE_G_ProductIds';

const {
  PDP_PAGE: {
    PDP_ZONE_A, PDP_ZONE_B, PDP_ZONE_G, PDP_ZONE_F, PDP_ZONE_I, PDP_ZONE_H,
  },
} = prosZones;

const getLSKey = (zone) => ((zone === PDP_ZONE_G || zone === PDP_ZONE_F) ? PDP_ZONE_G_LS_KEY : PDP_ZONE_A_LS_KEY);

export default {
  namespaced: true,
  state: {
    wishlistLoaded: false,
    recommendations: {},
    zoneRecommendationMap: {},
    panelLoadedMap: {},
    recommendationProductIds: {},
    pageId: null,
  },
  getters: {
    recommendationProductIds(state) {
      return state.recommendationProductIds;
    },
  },
  mutations: {
    [SET_RECOMMENDATIONS](state, { config, properties, response }) {
      const {
        recommendationsOnAllZones,
        recommendedItems,
        productCollection,
        zone,
      } = response;

      if (recommendedItems) {
        recommendedItems.productCollection = productCollection?.map((item) => item.product);
      }

      const workflow = getWorkflow(config, zone || config.zone);

      if (
        !response
        || !config
        || !(
          recommendedItems
          || (recommendationsOnAllZones
            && Object.keys(recommendationsOnAllZones).length > 0)
        )
      ) {
        if (config.zone === PDP_ZONE_A) {
          state.recommendationProductIds[config.zone] = '';
        }
        state.zoneRecommendationMap[workflow] = recommendedItems;
        return;
      }

      if ([PDP_ZONE_A, PDP_ZONE_G].includes(config.zone)) {
        state.recommendationProductIds[config.zone] = [];
        state.recommendationProductIds[config.zone] = (recommendedItems?.recommendedIdsList || [])
          .map((item) => item.id)
          .join('|');
      }
      // // For single zone recommendation => read it from recommendedItems
      const { filterOverlappingProsProducts: overlap } = properties;
      const LSKey = getLSKey(zone);

      if (recommendedItems && overlap) {
        if ([PDP_ZONE_A, PDP_ZONE_G].includes(zone)) {
          localStorage.setItem(
            LSKey,
            (recommendedItems?.recommendedIdsList || [])
              .map((item) => item.id)
              .slice(0, 5),
          );
        }
        const productIds = getPersistent(LSKey) || '';
        if ([PDP_ZONE_B, PDP_ZONE_F, PDP_ZONE_I, PDP_ZONE_H].includes(zone) && productIds.length > 0) {
          const ids = productIds.split(',').map((pid) => parseInt(pid, 10));
          const newRecommendedIdsList = response.recommendedItems.recommendedIdsList.filter((item) => ids.includes(item.id));
          response.recommendedItems.recommendedIdsList = newRecommendedIdsList;
          localStorage.removeItem(LSKey);
        }
      }

      if (recommendedItems) {
        state.zoneRecommendationMap[workflow] = recommendedItems;
        // PageApp.channel.trigger(`${workflow}${ProsEvents.dataAvailable}`, recommendedItems, config);
      } else {
        // PageApp.channel.trigger(`${workflow}${ProsEvents.failure}`, config);
      }
    },
    [SET_PANEL_LOADED_STATE](state, { workflow, isLoaded, isFailed }) {
      state.panelLoadedMap[workflow] = { isLoaded, isFailed };
    },
    [SET_WISHLIST_LOADED](state, loaded) {
      state.wishlistLoaded = loaded;
    },
    [SET_PAGE_ID](state) {
      state.pageId = generateUniqueString();
    },
  },
  actions: {
    async [GET_RECOMMENDATIONS]({ commit }, { config, properties }) {
      let response;
      try {
        response = await getRecommendations({ config, properties });
      } catch (e) {
        response = {
          status: 'FAILURE',
          error: {
            code: null,
            description: e,
          },
          recommendedItems: null,
          recommendationsOnAllZones: null,
        };
      }
      commit(SET_RECOMMENDATIONS, { config, properties, response });
      return response;
    },
  },
};
